import {Injectable, Inject} from 'ng-metadata/core';
import {AddQueryToSavedSearchesService} from "../../../../search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service";


@Injectable()
export class MendeleyToastService {
    private inProgress: boolean = false;
    constructor(private addQueryToSavedSearchesService: AddQueryToSavedSearchesService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService){
    }

    public showMendeleyToast(isSuccess: boolean, title: string){
        this.$timeout(() => {
            if(this.$mdToast){
                this.$mdToast.hide().then(()=>{
                    this.inProgress = false;
                    this.$timeout(() => {
                        let templateString = '<prm-mendeley-toast is-success="' + (isSuccess?'true':'') + '" title="' + title + '"></prm-mendeley-toast>';
                        if(!this.inProgress){
                            this.$mdToast.show({
                            hideDelay   : isSuccess? 2500:8000,
                            position    : 'top right',
                            template : templateString
                        }).then(()=>{
                            this.addQueryToSavedSearchesService.onToastClose();
                        });;
                    }
                    }, 750);
                });
            }
        }, 1000);
    }

    public showInProgressToast(){
        let templateString = '<prm-mendeley-toast in-progress="true"></prm-mendeley-toast>';
        if(!this.inProgress){
            this.inProgress = true;
            this.$mdToast.show({
                hideDelay   : 0,
                position    : 'top right',
                template : templateString
            }).then(()=>{
                this.addQueryToSavedSearchesService.onToastClose();
            });
        }
    }

    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/mendeleyAction/mendeleyToast/mendeleyToast.service.ts